// extracted by mini-css-extract-plugin
export default {"tabs":"gLt8riRg3y"};